export default function AttachStatementFolderDirective() {
  return {
    template: require('./attach-statement-folder.html'),
    scope: {
      customerId: '=',
      criStatementId: '=',
      assessmentId: '=',
      serviceId: '=',
      parentFolderId: '=',
      folderId: '=',
      folder: '=',
    },
    controller: 'AttachStatementFolderController',
    controllerAs: 'attachStatementFolderVM',
    bindToController: true,
    replace: true
  };
}
